import { NavigationEnd, NavigationStart } from '@angular/router'
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity'
import { Field, EntityConfiguration } from '../../modules/dto'
import { NavStateContainerBase } from '../../modules/navigation-state'

export const pageStateFeatureKey = 'pageState'

// unfortunate naming schema. might have to rename the whole thing. (open for suggestions)
export interface PageStateState extends EntityState<NavStateContainerBase> {
  lastNavStart: NavigationStart
  lastNavEnd: NavigationEnd
  currentDtoType: DtoType
  currentEntity: any[]
}

export interface DtoType {
  config: EntityConfiguration
  headerFields: Field[]
  editableFields: Field[]
  creationFields: Field[]
  excludedPanels: string[]
}

export const pageStateAdapter: EntityAdapter<NavStateContainerBase> = createEntityAdapter<NavStateContainerBase>({
  // https://stackoverflow.com/a/50626015/5536342
  selectId: (pageState: NavStateContainerBase) => pageState.tokenObj.token
})

export const initialPageStateState: PageStateState = pageStateAdapter.getInitialState({
  lastNavStart: null,
  lastNavEnd: null,
  currentDtoType: null,
  currentEntity: null
})
